import type { PlatformServices, StorageService } from './types';

const webStorage: StorageService = {
  get: async (key) => localStorage.getItem(key),
  set: async (key, value) => { localStorage.setItem(key, value); },
  remove: async (key) => { localStorage.removeItem(key); },
};

export function createWebServices(): PlatformServices {
  return {
    storage: webStorage,
    update: null,
    kiosk: null,
    app: null,
    wol: null,
  };
}
